export const FIELD_TYPE = {
  ADDRESS: 'ADDRESS',
  CURRENCY: 'CURRENCY',
  CHECKBOX: 'CHECKBOX',
  CHECKBOX_GROUP: 'CHECKBOX_GROUP',
  COLLECTION: 'COLLECTION',
  DATE: 'DATE',
  DROPDOWN: 'DROPDOWN',
  EMAIL: 'EMAIL',
  GROUP: 'GROUP',
  HEADING: 'HEADING',
  LINKTO: 'LINKTO',
  LOOKUP: 'LOOKUP',
  MONTH_YEAR: 'MONTH_YEAR',
  NAME: 'NAME',
  PHONE: 'PHONE',
  POSTCODE: 'POSTCODE',
  RADIO: 'RADIO',
  TEXTAREA: 'TEXTAREA',
  CUSTOM: 'CUSTOM',
  DOCUMENTS: 'DOCUMENTS',
  PANELS: 'PANELS',
  BUTTON: 'BUTTON',
  NUMBER: 'NUMBER'
}

export const HEARTBEAT_EXEMPTIONS = [
  'ConfirmationView',
  'ErrorView',
  'LoginView',
  'PilotView',
  'WelcomeView',  
  'LogoutView'
]

export const ALERT_TYPE = {
  MISSING: 'MISSING',
  INVALID: 'INVALID',
  CONFLICT: 'CONFLICT'
}

export const ADDRESS_VALIDATION = {
  UNKNOWN: 'N',
  VALID: 'V'
}
export const ERROR_CODES = {
  NO_PENDING: 'NO_PENDING',
  NETWORK_ERROR: 'NETWORK_ERROR',
  API: 'API'
}

export const API_ERROR_SUBTYPES = {
  initiateAuth: 'PILIA',
  submit: 'PILSU',
  getApplication: 'PILRE'
}

export const REFDATA_MAP = {  
  RELATIONSHIP: 'Relationship',  
  TITLE: 'Title',
  LANGUAGES: 'Languages',  
  LANGUAGES_POPULAR: 'LanguagesPopular',
  CONTACT_TYPE: 'ContactType',
  STATES: 'States'
}

// Default api date format
export const DATE_FORMAT = 'YYYY-MM-DD'

// Used as the value for intendedStartDate when enterStartDate is specified
export const CHOOSE_DATE = 'Choose a specific start date'


export const NODE_ENVIRONMENTS = {
  LOCAL: 'LOCAL',
  DEV: 'DEV',
  TEST: 'TEST',
  PREPROD: 'PRE',
  PROD: 'PROD',
  TRAIN: 'TRAIN'
}

export const CATEGORY_UPLOAD_STATUSES = {
  UPLOADING: 'UPLOADING',
  REMOVING: 'REMOVING',
  COMPLETE: 'COMPLETE'
}